<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <!-- <a class="logo" href="#" (click)="navigateHome()">S-<span>buddy</span></a> -->
    <img class="logo title_logo" src="assets/images/SBHeader.png" alt="logo" />
  </div>
  <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select> -->
</div>


<div class="header-container">
  <nb-actions size="small">
    <!-- <nb-action class="control-item" icon="email-outline"></nb-action> -->
    <nb-action class="control-item notification-action" (click)="toggleNotifications()" title="Notifications">
      <nb-icon icon="bell-outline"></nb-icon>
      <span *ngIf="notificationCount > 0" class="notification-badge">{{ notificationCount }}</span>
    </nb-action>
     <nb-action
      class="control-item"
      icon="question-mark-circle-outline"
      title="Help"
      (click)="openHelpLink()">
    </nb-action>
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user
        [onlyPicture]="userPictureOnly"
        [name]="user?.name"
        [picture]="user?.picture"
        [nbContextMenu]="userMenu"
        (nbContextMenuClick)="onMenuItemClick($event)">
      </nb-user>
    </nb-action>
    
    <nb-action class="control-item" icon="log-out-outline" (click)="logout()" title="Log out"></nb-action>
  </nb-actions>

  <div class="chat-box notification-panel" *ngIf="isNotificationsOpen">
    <div class="chat-header notification-header">
      <div class="notification-header-content">
        <div class="notification-icon-badge">
          <nb-icon icon="bell-outline"></nb-icon>
        </div>
        <div>
          <div class="notification-title-row">
            <span class="notification-title">Notifications</span>
            <span class="notification-count" *ngIf="!isNotificationsLoading">{{ notifications.length }}</span>
          </div>
          <div class="notification-subtitle">Recent updates for your account</div>
        </div>
      </div>

      <button type="button" class="notification-close" (click)="toggleNotifications()" aria-label="Close notifications">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="chat-body notification-body">
      <div class="notification-state notification-loading-state" *ngIf="isNotificationsLoading">
        <div class="notification-state-icon">
          <nb-icon icon="loader-outline"></nb-icon>
        </div>
        <div>
          <div class="notification-state-title">Loading notifications</div>
          <div class="notification-state-subtitle">Fetching the latest updates for you</div>
        </div>
      </div>

      <div class="notification-state notification-empty-state" *ngIf="!isNotificationsLoading && !notifications.length">
        <div class="notification-state-icon">
          <nb-icon icon="bell-off-outline"></nb-icon>
        </div>
        <div>
          <div class="notification-state-title">No notifications yet</div>
          <div class="notification-state-subtitle">You are all caught up for now</div>
        </div>
      </div>

      <div class="notification-list" *ngIf="!isNotificationsLoading && notifications.length">
        <div class="notification-item" *ngFor="let notification of notifications; let i = index" (click)="markNotificationAsRead(notification)">
          <div class="notification-item-marker">{{ i + 1 }}</div>
          <div class="notification-item-content">
            <div class="notification-text">{{ getNotificationText(notification) }}</div>
            <div class="notification-time" *ngIf="getNotificationTime(notification)">
              {{ getNotificationTime(notification) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
